import React, { memo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Icon from 'src/components/Icon/Icon';
import StakeInput from 'src/components/StakeInput/StakeInput';
import { RootState } from 'src/configs/store';
import { formatAmountToFixed } from 'src/utils/utils';
import './BetStakes.scss';

interface StakeProps {
  validMessage: string,
  allowStakes: boolean,
  amount: string,
  maximumProfit: number | string
  onAmountChange: Function,
  marketStatusNumber: number,
  marketStatusName: string,
  outcomeStatusNumber: number,
  outcomeStatusName: string,
  showCombinableWarning: boolean,
  combinationExclusions: number[],
  handleUpdate: () => void,
  index: number,
  divisor: number
}

function BetStakes({ validMessage,
  amount,
  onAmountChange,
  maximumProfit,
  allowStakes,
  handleUpdate,
  marketStatusName,
  outcomeStatusName,
  outcomeStatusNumber,
  marketStatusNumber,
  showCombinableWarning,
  combinationExclusions,
  index,
  divisor
}: StakeProps) {
  const selectedSlip = useSelector((state: RootState) => state.betslip.slip);
  const { singleSlip } = useSelector((state: RootState) => state.betslip);

  const isSuspended = marketStatusNumber === 3 || outcomeStatusNumber === 3;
  const suspendedName = +marketStatusNumber === 3 ? marketStatusName : outcomeStatusName;
  const dispatch = useDispatch();

  const { t } = useTranslation();

  return (
    <>
      <div className="bet-stakes">
        {
          selectedSlip === 0 && (
            <>
              <div className="bet-stakes__stake-container">
                {
                  validMessage !== '' && singleSlip.stakeSelection === 'differentStake' &&(
                    <Icon icon="warningFilled" className="bet-stakes__warning-icon" />
                  )
                }
                <span className="bet-stakes__title">{ t('betslip.stake') }</span>
                <StakeInput
                  rule="sports.single"
                  type="bet"
                  onChange={ onAmountChange }
                  defaultValue={ amount.toString() }
                  name="amount"
                  className="bet-stakes__input"
                  disabled={ !allowStakes || isSuspended }
                />
              </div>
              <div className={
                classNames({
                  'bet-stakes__profit-container': true,
                  'bet-stakes__profit-container--break': (maximumProfit.toString()).length > 7
                })
              }
              >
                <span className="bet-stakes__title">{ t('betslip.potProfit') }</span>
                <input
                  type="number"
                  step=".01"
                  autoComplete="new-password"
                  min="0"
                  className="bet-stakes__input bet-stakes__input--profit"
                  disabled={ true }
                  value={ formatAmountToFixed(+maximumProfit, divisor, true) }
                />
              </div>
            </>
          )
        }
      </div>
      {
        validMessage !== '' && singleSlip.stakeSelection === 'differentStake' &&(
          <div className="bet-stakes__minimum-warning"><span>
            { validMessage }
          </span>
          <div onClick={ handleUpdate } className="bet-stakes__update">Update</div>
          </div>
        )
      }
      {
        showCombinableWarning && (
          <div className="bet-stakes__combinable">{ t('betslip.notCombinable') } { combinationExclusions.toString() }</div>
        )
      }
      {
        isSuspended &&<div className="bet-stakes__suspended">
          <span>{ t('betslip.marketSuspended') }</span>
          <span>{ suspendedName }</span>
          <button onClick={ () => dispatch.betslip.removeBetAtIndex(index) } className="bet-stakes__btn-remove">{ t('betslip.removeBet') }</button>
        </div>
      }
    </>
  );
}

export default memo(BetStakes);
